export const Admin = {
    SET_CPTIES: "admin.set_cpties",
    SET_SELECTED_CPTY: "admin.set_selected_cpty",
    SET_LOADING: "admin.set_loading",
    SET_ERROR: "admin.set_error",
    SET_ONBOARD_STATUS: "admin.set_onboard_status",
    SET_FEATURE_FLAGS: "admin.set_feature_flags",
    SET_FLAGS_LOADING: "admin.set_flags_loading",
    SET_FLAGS_ERROR: "admin.set_flags_error",
    SET_USERS: "admin.set_users",
    SET_USERS_LOADING: "admin.set_users_loading",
    SET_USERS_ERROR: "admin.set_users_error",
};
